import React, { useState, useEffect, useRef } from 'react';

export default function FixRequestList({ title, categoryList, handleCategoryClick, selectCategory }) {

    return (
        categoryList ? (
            <div style={{ padding: "3px 16px", flex: "1", overflowY: "scroll" }}>
                <div className='f18_1F2937_W400'>{title}</div>
                <div style={{ height: "20px" }} />

                {/* 대분류 리스트 */}
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    {Array.from({ length: Math.ceil(categoryList.length / 2) }).map((_, rowIndex) => (
                        <div
                            key={rowIndex}
                            style={{
                                display: 'flex',
                                flexDirection: "row",
                                gap: "16px",
                            }}
                        >
                            {categoryList.slice(rowIndex * 2, rowIndex * 2 + 2).map((item, index) => (
                                <div
                                    onClick={() => handleCategoryClick(index, item.name ?? "", item.tag)}
                                    key={item.id}
                                    draggable={false}
                                    style={{
                                        border: selectCategory.name === item.name ? "1px solid #2E4A24" : "1px solid #E5E7EB",
                                        backgroundColor: selectCategory.name === item.name ? "#E8F0E6" : "#ffffff",
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "102px",
                                        flex: "1",
                                        borderRadius: "12px",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "8px",
                                        padding: "16px",
                                        textAlign: "center",
                                        userSelect: "none",           // 텍스트 드래그 방지
                                        WebkitUserDrag: "none",      // 이미지 드래그 방지
                                        cursor: "pointer",
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    {item.icon && (
                                        <img src={`/${item.icon}`} alt="icon" />
                                    )}
                                    <div className='f14_1F2937_W400'>{item.name}</div>
                                </div>
                            ))}

                            {/* 마지막 줄이고 아이템이 홀수일 경우 빈 div로 채우기 */}
                            {rowIndex === Math.floor(categoryList.length / 2) && categoryList.length % 2 === 1 && (
                                <div
                                    style={{
                                        flex: "1",
                                        padding: "16px",
                                        backgroundColor: "transparent"
                                    }}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        ) : (
            <div style={{ padding: "3px 16px", flex: "1" }}>
            </div>
        )
    )
}